import { render } from "./PersonalDashboard.vue?vue&type=template&id=3abc332e&scoped=true&ts=true"
import script from "./PersonalDashboard.vue?vue&type=script&lang=ts"
export * from "./PersonalDashboard.vue?vue&type=script&lang=ts"

import "./PersonalDashboard.vue?vue&type=style&index=0&id=3abc332e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3abc332e"]])

export default __exports__